import { useCallback, useEffect, useState, useRef } from 'react';
import type { SessionConfig } from '../types';
import type { StorageScope } from '../constants/storage';
import { forgetStoredConversation, pruneStoredConversations } from '../utils/transcriptPrivacy';

export function useTranscriptPrivacy(
  scope: StorageScope,
  config?: SessionConfig,
  retentionDays?: number,
  onExpire?: () => void
) {
  const onExpireRef = useRef(onExpire);
  onExpireRef.current = onExpire;
  // Runs before useThread/useChat initialize their persisted state.
  useState(() => {
    pruneStoredConversations(scope, config, retentionDays);
    return true;
  });
  useEffect(() => {
    if (pruneStoredConversations(scope, config, retentionDays)) onExpireRef.current?.();
  }, [scope, config, retentionDays]);
  return useCallback(
    (sessionId?: string | null, threadId?: string | null) => {
      forgetStoredConversation(scope, config, sessionId, threadId);
    },
    [scope, config]
  );
}
